export default __webpack_public_path__ + "static/media/airstrapz-cbb-banner-2.573e6eef.jpg";